package com.iregained.eventapp.components.models

import kotlinx.serialization.Serializable

@Serializable
data class StaffProfile(
    val uid: String = "",
    val fullName: String = "",
    val email: String = "",
    val phone: String = "",
    val designation: String = "", // e.g., "Lead Therapist", "Event Coordinator"
    val role: String = "staff"
)